/** Server SOT: shared/clients/postcode.py — widget fallback only when MCP omits error text. */
export const POSTCODE_DELIVERY_ERROR =
  "Sorry, we do not deliver to that postcode";
export const POSTCODE_SERVICE_ERROR =
  "Postcode verification is temporarily unavailable. Please try again.";

/** MCP purchase_clarify_tools._NEXT_RETRY */
const NEXT_ACTION_RETRY = "retry_postcode";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** POST /api/widget/tool-call JSON-RPC body → structuredContent dict or null. */
export function extractStructuredContent(
  rpcBody: unknown,
): Record<string, unknown> | null {
  if (!isRecord(rpcBody)) {
    return null;
  }
  if (rpcBody.error !== undefined) {
    return null;
  }
  const result = rpcBody.result;
  if (!isRecord(result)) {
    return null;
  }
  const structured = result.structuredContent;
  if (!isRecord(structured)) {
    return null;
  }
  return structured;
}

function resolveFailureMessage(structured: Record<string, unknown>): string {
  const serverError = structured.error;
  const trimmed =
    typeof serverError === "string" && serverError.trim()
      ? serverError.trim()
      : "";
  if (structured.next_action === NEXT_ACTION_RETRY) {
    return trimmed || POSTCODE_SERVICE_ERROR;
  }
  return trimmed || POSTCODE_DELIVERY_ERROR;
}

export function parseValidatePostcodeResult(rpcBody: unknown): {
  ok: boolean;
  errorMessage: string;
} {
  const structured = extractStructuredContent(rpcBody);
  if (!structured) {
    console.warn("[parseValidatePostcode] missing structuredContent in tool-call response");
    return { ok: false, errorMessage: POSTCODE_SERVICE_ERROR };
  }
  if (structured.ok === true) {
    return { ok: true, errorMessage: "" };
  }
  return { ok: false, errorMessage: resolveFailureMessage(structured) };
}
